import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchPageByHandle } from '../../redux/actions/pageActions';
import ContentPageTemplate from '../templates/ContentPageTemplate';
import SimplifiedHeader from '../common/SimplifiedHeader';
import Footer from '../naviagtions/Footer';

interface PageDetailParams {
  handle: string;
}

const PageDetail: React.FC = () => {
  const { handle } = useParams<PageDetailParams>();
  const dispatch = useDispatch();
  const { currentPage, isLoading, error } = useSelector((state: any) => state.pages);

  useEffect(() => {
    if (handle) {
      dispatch(fetchPageByHandle(handle));
    }
  }, [dispatch, handle]);

  if (isLoading) {
    return <div className="loading">Loading page...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  if (!currentPage) {
    return <div className="not-found">Page not found</div>;
  }

  // Determine if this page should use FAQ-style formatting
  // We can check if the page handle or title contains "faq", "frequently", etc.
  const isFaqPage = 
    currentPage.title.toLowerCase().includes('faq') || 
    currentPage.title.toLowerCase().includes('frequently') ||
    (typeof currentPage.handle === 'string' && 
      currentPage.handle.toLowerCase().includes('faq'));
  
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh' 
    }}>
      <SimplifiedHeader />
      <div className="page-detail" style={{ flex: '1 0 auto' }}>
        <ContentPageTemplate
          title={currentPage.title}
          content={currentPage.content}
          useFaqStyle={isFaqPage}
        />
        <div className="page-meta" style={{ 
          textAlign: 'center', 
          fontSize: '0.8rem', 
          color: '#777',
          marginTop: '2rem' 
        }}>
          <p>Last updated: {currentPage.updatedAt.toLocaleDateString()}</p>
        </div>
      </div>
      <div style={{ flexShrink: 0 }}>
        <Footer />
      </div>
    </div>
  );
};

export default PageDetail;
